import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { GrupoCompra } from '../classes/GrupoCompra';

@Injectable({
  providedIn: 'root'
})
export class GrupoCompraService {

  constructor(private http: HttpClient) { }

  toList(): Observable<any>{
    return this.http.get(`${environment.apiURL}/GrupoCompra`)
  }

  get(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/GrupoCompra/${id}`)
  }

  post(grupoCompra: GrupoCompra): Observable<any>{
    return this.http.post(`${environment.apiURL}/GrupoCompra`, grupoCompra);
  }

  put(id: number, grupoCompra: GrupoCompra): Observable<any>{
    return this.http.put(`${environment.apiURL}/GrupoCompra/${id}`, grupoCompra);
  }

  delete(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/GrupoCompra/${id}`);
  }

}
